import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpRequest, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { NotificationService } from '../../service/notification.service';
import { map, catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EncriptDecriptService } from '../../../../services/encriptdecript';

@Injectable()
export class AdminCourseService {

    constructor(private Http: HttpClient, private router: Router,
        public activeModal: NgbActiveModal,
        private encriptDecriptService:EncriptDecriptService,
        private notificationService: NotificationService) { }
    private standardHeaders() {
        return {
            'Content-Type': 'application/json',
            'token': this.encriptDecriptService.getKeyLocalStorage('token')
        };
    }

    goToLoginPage() {
        this.activeModal.close(); 
        this.router.navigate(['/login']);
        sessionStorage.clear();
        localStorage.clear();
        this.notificationService.sessionExpaireNotification();
      }

    //  no need to hit this /category/list anymore bcos to speedup the performance -17|07|18
    //to get isActive based categorylist 11-07-18
    getIsActivebasedCateogryList(isActive): Observable<any> {

        return this.Http.post(environment.api_url1 + '/category/adminViewList', { "isActive": isActive }, {
            headers: this.standardHeaders()
        }).pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }

    //to list all category
    getCategoryList(): Observable<any> {
        return this.Http.post(environment.api_url1 + '/category/list', {}, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );

    }
    //to list only on the view use this
    getCategoryviewList(): Observable<any> {
        return this.Http.post(environment.api_url1 + '/category/adminViewList', {}, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );

    }
    //to list only on the view use this for user admin
    getCategoryUserAdminViewList(isActive: any, orgId: any): Observable<any> {
        return this.Http.post(environment.api_url1 + '/category/userViewList?orgId=' + orgId, { 'isActive': isActive }, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );

    }
    //  get user-admin view list instead of adminviewList 28-02-2019 

    getCategoryListBasedonOrgId(organisationId): Observable<any> {
        return this.Http.post(environment.api_url1 + '/category/paramOrgList', { "organisation": { organisationId } }, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }

    getCategoryListBasedonOrgIdForCourseAssign(organisationId): Observable<any> {
        return this.Http.post(environment.api_url1 + '/category/paramOrgWithParentList', { "organisation": { organisationId } }, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }


    //saving,editing and delete we use same payload
    save(data: any): Observable<any> {

        return this.Http.post(environment.api_url1 + '/category', data, {
            headers: this.standardHeaders()

        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }



    deleteCategory(data) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json',
        'token':this.standardHeaders().token }), body:data};
        return this.Http.delete(environment.api_url1+'/category', httpOptions)
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );

    }
    //for getting datas in edit
    getCategoryById(CategoryId: any, isActive): Observable<any> {
        return this.Http.post(environment.api_url1 + '/category/params', { "categoryId": CategoryId, 'isActive': isActive }, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );

    }

    //// this categoryparentList
    getcatparentlist(): Observable<any> {

        return this.Http.post(environment.api_url1 + '/CategoryParent/list', {}, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }

    //assign user category
    getUserCategoryList(userId): Observable<any> {
        return this.Http.post(environment.api_url1 + '/userAssignedCategory/list', userId, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }


    /// bulk dalete for all category component 16:07:18
    bulkDeleteCategory(categoryIds): Observable<any> {

        return this.Http.post(environment.api_url1 + '/category/batchDelete', categoryIds,
         { headers: this.standardHeaders() })
         .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );

    }
    // upload for category level 20:08:2018 thiru

    categoryFileToStorage(file: File, image: File, category: any): Observable<HttpEvent<{}>> {
        let formdata: FormData = new FormData();

        formdata.append('file', file);
        formdata.append('image', image);
        formdata.append('categoryObject', JSON.stringify(category));
        var headers =new HttpHeaders({
            'token':this.encriptDecriptService.getKeyLocalStorage('token') 
        })
        const req = new HttpRequest('POST', environment.api_url1 + '/category', formdata,
         { headers:headers,reportProgress: true });

        return this.Http.request(req)
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }


    // userForAll SelectedCategoryId thiru 21:08:2018
    userForAllSelectedCategoryId(selectedOrganisationId: any, selectedCategoryId: any) {

        return this.Http.post(environment.api_url1 + '/categoryUserList', { 'organisationId': selectedOrganisationId, 'categoryId': selectedCategoryId }, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }

    // Assing course userFor SelectedUsers thiru 21:08:2018
    assignCategoryForUser(organisation: String,categoryId:Number ,data: any) {
        return this.Http.post(environment.api_url1 + '/categoryUser/'+categoryId+'?orgName=' + organisation['name']+'&orgId='+organisation['organisationId'], data, {
            headers: this.standardHeaders()

        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }

    categoryLaunchPath(userobj: any, categoryId: any): Observable<any> {
        return this.Http.post(environment.api_url1
            + '/category/launch?categoryId=' + categoryId, userobj,
            { headers: this.standardHeaders() })
            .pipe(
                map((response: any) => {
                  return response;
                }),
                catchError(error => {
                  if (error.status == 401) { this.goToLoginPage(); }
                  return _throw(error);
                })
              );

    }
    courseReorderingViewSequence(orgId: any): Observable<any> {
        return this.Http.post(environment.api_url1 + '/category/viewSequence', { organisation: { 'organisationId': orgId } }, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
          );
    }

    public courseReorderingUpdateSequence(orgId: any, categorySequenceObj: any): Observable<any> {
        return this.Http.post(environment.api_url1 + '/category/updateSequence?orgId=' + orgId,
     categorySequenceObj,{ headers: this.standardHeaders()})
     .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
    }

    public getCateogryListByOrgId(organisationId:any):Observable<any>{
        return this.Http.post(environment.api_url1+'/category/courseManagementViewList',
        {'organisationId':organisationId},
        {headers:this.standardHeaders()})
        .pipe(
          map((response: any) => {
            return response;
          }),
          catchError(error => {
            if (error.status == 401) { this.goToLoginPage(); }
            return _throw(error);
          })
        );
    }
}


// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/course/services/admin-course.service.ts